import { Ask } from '../Ask/ask.service';
import { Field } from '../Field/field';
import { ModulesManagerService } from '../Module/modules-manager.service';
import { UserService } from '../User/user.service';
import { LoggerService } from '../../utils/logger.service';

export class FieldsTempaltesConditions {
    protected id: number = 0;
    protected manager: ModulesManagerService;
    protected hydrated: boolean = false


    private fieldsTemplateId: number = 0;
    private type: number = 0;
    private targetField: string = "";
    private operator: number = 0;
    private value: string = "";

    constructor(manager: ModulesManagerService, Data = null) {
        this.manager = manager
        if (Data != null) this.Hydrate(Data)
    }

    protected async OnHydrated() {
        this.operator = parseInt(this.operator + "")
        this.type = parseInt(this.type + "")
    }

    get FieldsTemplateId() {
        return this.fieldsTemplateId
    }

    private checkAboutState(ask: Ask): boolean {
        let states: any = this.value.split(";").map(val => parseInt(val))
        switch (parseInt(this.operator + "")) {
            case 4:
            case 2:// a.include(b)
                return states.includes(ask.State)
            case 5:
            case 3:// !a.include(b)
                return !states.includes(ask.State)
            default:
                LoggerService.error(`L'opérateur ${this.operator} n'est pas défini pour la vérification d'état`)
                return false
        }
    }


    getTargetField(ask: Ask) {
        return ask?.getField({ TargetField: this.targetField })
    }

    isTrue(field: Field, ask: Ask) {
        if (ask?.isTwoSideAtTime) return true // si demandeur == responsable et que je suis owner alors je peux tous faire
        //+++ prévoir que include sur le champ états est mal gérer 
        let user: UserService = this.manager.Usr
        let targetField: Field = this.getTargetField(ask)
        if (this.type == 0) {
            if (!ask.isOwner) return true
        } else {
            if (ask.IsFake || ask.TargetId != user.UserId) return true
        }

        if (targetField?.TargetField == "State") return this.checkAboutState(ask)

        switch (targetField?.Type) {
            case "selector":
                return this.runSelectorTest(field, targetField)
            default:
                return this.runDefaultTest(field, targetField)
        }
    }

    runSelectorTest(field: Field, targetField: Field) {
        switch (parseInt(this.operator + "")) {
            case 4:// a == b
                var typeOfChecker: number = this.value.split(";").map(val => parseInt(val))[0]
                if (typeOfChecker == 0) {
                    return parseInt(targetField?.orginialValue || 0) == 0
                } else {
                    return parseInt(targetField?.orginialValue || 0) != 0
                }
            case 5:// a != b
                var typeOfChecker: number = this.value.split(";").map(val => parseInt(val))[0]
                if (typeOfChecker == 1) {
                    return parseInt(targetField?.orginialValue || 0) == 0
                } else {
                    return parseInt(targetField?.orginialValue || 0) != 0
                }
            default:
                LoggerService.error(`L'opérateur ${this.operator} n'est pas défini pour le sélecteur`)
                return this.runDefaultTest(field, targetField)
        }
    }

    runDefaultTest(field: Field, targetField: Field) {
        switch (parseInt(this.operator + "")) {
            case 0://a > b
                return parseInt(field.Value) > parseInt(targetField?.Value)
            case 1:// a < b
                return parseInt(field.Value) < parseInt(targetField?.Value)
            case 2:// a.include(b)
                return field.Value.includes(targetField?.Value)
            case 3:// !a.include(b)
                return !field.Value.includes(targetField?.Value)
            case 4:// a == b              
                return field.Value == targetField?.Value
            case 5:// a != b               
                return field.Value != targetField?.Value
            case 6://a >= b
                return parseInt(field.Value) >= parseInt(targetField?.Value)
            case 7:// a <= b
                return parseInt(field.Value) <= parseInt(targetField?.Value)
            default:
                LoggerService.error(`L'opérateur ${this.operator} n'est pas défini`)
                return true
        }
    }

    async Hydrate(Data) {
        //if(this.hydrated) return this;
        this.hydrated = true
        for (const [key, propertie] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(key)] = propertie
        await this.OnHydrated()
        return this
    }
}
